var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PostPurchaseScreen',{attrs:{"title":"ORDER AWAITING REVIEW","body":"Thanks for placing your order! Keep an eye on your email and we'll email you on instructions on how to continue when it's been approved!"}})}
var staticRenderFns = []

export { render, staticRenderFns }